var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupeeCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM8 6.25H16C16.4142 6.25 16.75 6.58579 16.75 7C16.75 7.41421 16.4142 7.75 16 7.75H13.4235C13.9246 8.35395 14.2707 9.10104 14.4037 9.91667H16C16.4142 9.91667 16.75 10.2525 16.75 10.6667C16.75 11.0809 16.4142 11.4167 16 11.4167H14.4037C14.152 12.9599 13.1374 14.2578 11.7536 14.805L14.2621 17.4878C14.545 17.7903 14.5291 18.2649 14.2265 18.5478C13.924 18.8307 13.4494 18.8148 13.1665 18.5122L9.7379 14.8456C9.53384 14.6273 9.47877 14.3088 9.59772 14.0347C9.71667 13.7607 9.98694 13.5833 10.2857 13.5833C11.493 13.5833 12.5676 12.6904 12.8759 11.4167H8C7.58579 11.4167 7.25 11.0809 7.25 10.6667C7.25 10.2525 7.58579 9.91667 8 9.91667H12.8759C12.5676 8.64298 11.493 7.75 10.2857 7.75H8C7.58579 7.75 7.25 7.41421 7.25 7C7.25 6.58579 7.58579 6.25 8 6.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeeCoin);
export default __webpack_public_path__ + "static/media/rupee-coin.309b968a308f3d7bb18eff2cbfbd2c56.svg";
export { ForwardRef as ReactComponent };